import React from 'react'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import './../assets/table.css'
import dashboardIcon from '../images/disabledDashboardIcon.svg'
import arrowDownIcon from '../images/arrowDownIcon.svg'
import enabledCheckIcon from '../images/enabledCheckIcon.svg'
import moment from 'moment-timezone'
import { Redirect } from 'react-router'
import Pagination from './Pagination'
import ButtonWithSwitch from '../components/ButtonWithSwitch'
import ButtonRefreshWithoutIcon from './ButtonRefreshWithoutIcon'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import {
  CURRENT_METRIC,
  CURRENT_METRIC_UPDATED,
  SEARCH_METRICS
} from '../query/metric'
import _ from 'lodash'
import { client } from '../graphql/client'
moment.locale('fr')

class FullListContent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      page: 1,
      pageSize: null,
      pageOfItems: [],
      data: this.updateMetricStructure(props.fullMetrics),
      headers: [
        'Heure',
        'Véhicules',
        'Volumes'
      ],
      vehicleNumber: null,
      stopSubscription: false,
      trackableLabel: null,
      trackableName: null,
      switchValue: true,
      vehicleDisplayMode: localStorage.getItem('vehicleDisplayMode') || 'registration',
      showVehicleMenu: false
    }
    this.onChangePage = this.onChangePage.bind(this)
  }

  goToDashbordByVehicle (trbImm, trackableLabel, trackableName) {
    const self = this
    localStorage.setItem('vehicleNumber', trbImm)
    localStorage.setItem('trackableLabel', trackableLabel)
    localStorage.setItem('trackableName', trackableName)
    self.setState({
      vehicleNumber: trbImm,
      trackableLabel: trackableLabel,
      trackableName: trackableName
    })
  }

  toggleVehicleMenu = () => {
    this.setState({
      showVehicleMenu: !this.state.showVehicleMenu
    })
  }

  setVehicleDisplayMode = (mode) => {
    localStorage.setItem('vehicleDisplayMode', mode)
    this.setState({
      vehicleDisplayMode: mode,
      showVehicleMenu: false
    })
  }

  getVehicleDisplay = (element) => {
    if (this.state.vehicleDisplayMode === 'full_label') {
      return element.name || element.registration_number
    }
    return element.registration_number
  }

  isBeforeToday (occurredAt) {
    // Get today's date at midnight (start of day)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    
    // Parse the occurred_at timestamp
    const occurredDate = new Date(occurredAt)
    
    // Return true if occurred_at is before today
    return occurredDate < today
  }

  getSensorIds () {
    return this.props.sensorIds
  }

  searchMetrics (keySearch) {
    const { data } = this.state
    if (!keySearch || keySearch === '') {
      return data
    }

    const searchLower = keySearch.toLowerCase()
    return data.filter(metric => {
      return metric.registration_number &&
             metric.registration_number.toLowerCase().includes(searchLower)
    })
  }

  componentWillReceiveProps (nextProps) {
    const self = this
    // Handle keySearch changes
    if (self.props.keySearch !== nextProps.keySearch) {
      var keySearch = nextProps.keySearch
      if (keySearch !== '') {
        const filteredData = self.searchMetrics(keySearch)
        self.setState({
          data: filteredData,
          stopSubscription: true,
          isSorted: true,
          switchValue: false
        })
      }
      if (keySearch === '' && self.state.stopSubscription) {
        self.setState({
          data: self.updateMetricStructure(nextProps.fullMetrics),
          stopSubscription: false,
          isSorted: false,
          switchValue: true
        })
      }
    }
    // Handle sortMetrics changes when no active search
    if (self.props.fullMetrics !== nextProps.fullMetrics) {
      if (!nextProps.keySearch || nextProps.keySearch === '') {
        self.setState({
          data: self.updateMetricStructure(nextProps.fullMetrics)
        })
      }
    }
  }

  onChangePage (pageOfItems) {
    const self = this
    self.setState({
      pageOfItems: pageOfItems
    })
  }

  getPage (page, pageSize) {
    if (page === 1 && this.state.switchValue) {
      this.setState({
        stopSubscription: false,
        page: page,
        pageSize: pageSize
      })
    } else {
      this.setState({
        stopSubscription: true,
        page: page,
        pageSize: pageSize
      })
    }
  }

  updateMetricStructure (metrics) {
    const trackables = this.props.trackables || []
    let dataAllList = []
    metrics.forEach(function (element, key) {
      if (element.metadata && ((element.value * 100) / element.metadata.tank_capacity) >= 75) {
        let values = {}
        for (let tag in element) {
          if (tag === 'metadata') {
            for (let subTag in element[tag]) {
              values[subTag] = metrics[key][tag][subTag]
            }
          } else {
            values[tag] = element[tag]
          }
          // Ajouter la description depuis trackables
          if (values.trackable_label) {
            const trackable = trackables.find(t => t.label === values.trackable_label)
            if (trackable && trackable.name) {
              values.name = trackable.name
            }
          }
        }
        dataAllList.push(values)
      }
    })
    let dataSortByHours = _.orderBy(
      dataAllList, ['occurred_at'], 'desc'
    )
    return dataSortByHours
  }

  getHeader () {
    let header = this.state.headers
    return (
      <Thead style={styles.theadStyle}>
        <Tr>
          <Th
            height='38px'
            style={styles.thHour}
          >
            <span>{header[0]}</span>
          </Th>
          <Th
            style={styles.thVehicle}
          >
            <div style={styles.vehicleHeaderContainer}>
              <div style={styles.vehicleMenuContainer}>
                <img
                  src={arrowDownIcon}
                  alt='menu'
                  style={styles.menuIcon}
                  onClick={this.toggleVehicleMenu}
                />
                {this.state.showVehicleMenu && (
                  <div style={styles.vehicleDropdownMenu}>
                    <div style={styles.dropdownTitle}>Afficher :</div>
                    <div
                      style={styles.dropdownItem}
                      onClick={() => this.setVehicleDisplayMode('registration')}
                    >
                      {this.state.vehicleDisplayMode === 'registration' && (
                        <img src={enabledCheckIcon} alt='check' style={styles.checkIcon} />
                      )}
                      <span style={this.state.vehicleDisplayMode === 'registration' ? styles.dropdownItemTextActive : styles.dropdownItemText}>
                        Immatriculation
                      </span>
                    </div>
                    <div
                      style={styles.dropdownItem}
                      onClick={() => this.setVehicleDisplayMode('full_label')}
                    >
                      {this.state.vehicleDisplayMode === 'full_label' && (
                        <img src={enabledCheckIcon} alt='check' style={styles.checkIcon} />
                      )}
                      <span style={this.state.vehicleDisplayMode === 'full_label' ? styles.dropdownItemTextActive : styles.dropdownItemText}>
                        Libellé
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <span>{header[1]}</span>
            </div>
          </Th>
          <Th
            style={styles.thVolumes}
          >
            <span>{header[2]}</span>
          </Th>
        </Tr>
      </Thead>
    )
  }

  getBody () {
    const self = this
    const pageOfItems = self.state.pageOfItems
    return (
      <Tbody style={styles.tbodyStyle}>
        {
          pageOfItems.map((element, key) => {
            const isDisabled = self.isBeforeToday(element.occurred_at)
            return (
              <Tr
                key={`${key}_tr`}
                style={isDisabled ? styles.trStyleDisabled : styles.trStyle}
                onClick={isDisabled ? undefined : () => { self.goToDashbordByVehicle(element.registration_number, element.trackable_label, element.name) }}
              >
                <Td className='tdDateAndTime'>
                  <span
                    className='marginHour'>{moment.utc(element.occurred_at).tz('Indian/Antananarivo').format('DD/MM/YYYY')}
                  </span><br />
                  <span
                    className='marginHour'>{moment.utc(element.occurred_at).tz('Indian/Antananarivo').format('HH:mm')}
                  </span>
                </Td>
                <Td style={styles.tdVehicle}>
                  <span>
                    {this.getVehicleDisplay(element)}
                  </span>
                </Td>
                <Td className='tdVolumes'>
                  <div
                    className='marginTitle'
                  >
                    <div style={styles.divStyle}>
                      <span
                        style={styles.spanFull}
                      >
                        {element.value.toFixed(2)} Litres
                      </span>
                    </div>
                    <div>
                      <img
                        src={dashboardIcon}
                        style={styles.iconStyle}
                        alt='true'
                      />
                    </div>
                  </div>
                </Td>
              </Tr>
            )
          })}
      </Tbody>
    )
  }

  getPagination () {
    const self = this
    let data = self.state.data
    return (
      <Pagination
        items={data}
        onChangePage={this.onChangePage}
        getPage={(page, pageSize) => this.getPage(page, pageSize)}
      />
    )
  }

  refreshPage () {
    this.props.fetchData()
    this.setState({
      switchValue: true
    })
  }

  handleChange () {
    const self = this
    if (!self.state.switchValue) {
      if (this.props.keySearch === null || this.props.keySearch === '') {
        this.setState({
          switchValue: !self.state.switchValue,
          stopSubscription: false
        })
      }
    } else {
      this.setState({
        switchValue: !self.state.switchValue,
        stopSubscription: true
      })
    }
  }

  render () {
    const self = this
    if (this.state.vehicleNumber && this.state.trackableLabel) {
      return <Redirect
        to={{
          pathname: `/${localStorage.getItem('endpoint')}/dashboard-by-vehicle`,
          state: {
            vehicleNumber: this.state.vehicleNumber,
            trackableLabel: this.state.trackableLabel,
            trackableName: this.state.trackableName
          }
        }}
      />
    }
    if (this.state.data.length === 0) {
      return (
        <div style={styles.titleNothing}>
          Aucun résultat
        </div>
      )
    }
    return (
      <div>
        <div>
          <ButtonRefreshWithoutIcon
            disabled={this.state.switchValue}
            checked={this.state.switchValue}
            onClick={() => this.refreshPage()}
            label='Maj manuelle'
          />
          <ButtonWithSwitch
            checked={this.state.switchValue}
            onClick={() => this.handleChange()}
            handleChange={() => this.handleChange()}
            label='Maj auto'
          />
        </div>
        <div style={styles.content}>
          <div>
            <Table cellSpacing='0' cellPadding='0' style={styles.tableStyle}>
              {self.getHeader()}
              {self.getBody()}
            </Table>
            {self.getPagination()}
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  content: {
    width: '100%'
  },
  titleNothing: {
    marginTop: '25px',
    color: '#7ED321'
  },
  tableStyle: {
    width: '100%',
    marginTop: '-16px',
    borderSpacing: '0px 12px'
  },
  hidden: {
    display: 'none'
  },
  theadStyle: {
    fontSize: '14px',
    textAlign: 'left',
    color: '#F2F2F2'
  },
  thHour: {
    cursor: 'pointer',
    paddingLeft: '14px'
  },
  thVehicle: {
    position: 'relative',
    width: '400px',
    minWidth: '400px',
    maxWidth: '400px'
  },
  vehicleHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  vehicleMenuContainer: {
    position: 'relative',
    marginRight: '8px'
  },
  menuIcon: {
    width: '12px',
    height: '12px',
    cursor: 'pointer'
  },
  vehicleDropdownMenu: {
    position: 'absolute',
    top: '25px',
    left: '0',
    backgroundColor: '#2C343A',
    border: '1px solid #444',
    borderRadius: '4px',
    padding: '8px',
    minWidth: '180px',
    zIndex: 1000,
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
  },
  dropdownTitle: {
    fontSize: '12px',
    color: '#AAA',
    marginBottom: '8px',
    paddingLeft: '8px'
  },
  dropdownItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 8px',
    cursor: 'pointer',
    borderRadius: '3px',
    marginBottom: '4px'
  },
  dropdownItemText: {
    fontSize: '13px',
    color: '#F2F2F2',
    marginLeft: '8px'
  },
  dropdownItemTextActive: {
    fontSize: '13px',
    color: '#7ED321',
    marginLeft: '8px',
    fontWeight: 'bold'
  },
  checkIcon: {
    width: '14px',
    height: '14px'
  },
  tdVehicle: {
    width: '400px',
    minWidth: '400px',
    maxWidth: '400px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  thVolumes: {
    cursor: 'pointer',
    width: '30%',
    textAlign: 'right',
    paddingRight: '15px'
  },
  tbodyStyle: {
    backgroundColor: '#16191C',
    fontSize: '14px',
    height: '80px',
    textAlign: 'left',
    color: '#F2F2F2'
  },
  trStyle: {
    cursor: 'pointer'
  },
  trStyleDisabled: {
    cursor: 'not-allowed',
    opacity: 0.5
  },
  spanFull: {
    color: '#7ED321'
  },
  divStyle: {
    marginRight: '15px'
  },
  buttonStyle: {
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    width: '28px',
    height: '22px'
  },
  buttonS: {
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    width: '28px',
    height: '22px'
  },
  imgStyle: {
    marginLeft: '20px'
  },
  iconStyle: {
    width: '20px',
    height: '20px',
    marginRight: '14px'
  },
  transparent: {
    width: '20px',
    height: '20px',
    color: 'transparent'
  },
  pStyle: {
    fontSize: '14px',
    fontWeight: 'bold'
  }
}

export default FullListContent
